import React from "react";
import ConectaZapSuccessIcon from "../../../components/icons/ConectaZapSuccessIcon";
import ConectaZapErrorIcon from "../../../components/icons/ConectaZapErrorIcon";
import ConectaZapWarningIcon from "../../../components/icons/ConectaZapWarningIcon";

const StatusCircle = ({ status }) => {
  let statusColor = "";
  switch (status) {
    case "connected":
      statusColor = "#00C853";
      break;
    case "disconnected":
      statusColor = "#FF5252";
      break;
    default:
      statusColor = "#FAB11E";
      break;
  }

  return (
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: 40,
        backgroundColor: statusColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {status === "connected" ? (
        <ConectaZapSuccessIcon />
      ) : status === "disconnected" ? (
        <ConectaZapErrorIcon />
      ) : (
        <ConectaZapWarningIcon />
      )}
    </div>
  );
};

export default StatusCircle;
